export default __webpack_public_path__ + "static/media/delivery-cart.2413cf7d.png";